// extracted by mini-css-extract-plugin
export default {"container":"rZ-z","list":"sZ-z"};